function getUserOnStorage() {
  let user = localStorage.getItem('user-tc');

  if (user) {
    user = atob(user);

    return JSON.parse(user);
  }

  return undefined;
}

function saveUserOnStorage(user) {
  user = btoa(JSON.stringify(user));
  localStorage.setItem('user-tc', user);
}

function saveTokenOnStorage(token) {
  localStorage.setItem('token-tc', token);
}

function getTokenOnStorage() {
  return localStorage.getItem('token-tc');
}

function removeAuth() {
  localStorage.removeItem('token-tc');
  localStorage.removeItem('user-tc');
}

function setThemeSettings(darkMode) {
  localStorage.setItem('isDark', !!darkMode);
}

function getThemeSettings() {
  const valor = localStorage.getItem('isDark');

  return !!(valor == 'true');
}

function saveCustomerOnStorage(customer) {
  customer = btoa(JSON.stringify(customer));
  localStorage.setItem('customer-ch', customer);
}

function getCustomerOnStorage() {
  let customer = localStorage.getItem('customer-ch');

  if (customer) {
    customer = atob(customer);

    return JSON.parse(customer);
  }

  return undefined;
}

function removeCustomer() {
  localStorage.removeItem('customer-ch');
}

function saveCustomerCacheExpOnStorage(tokenExp) {
  localStorage.setItem('customer-exp-ch', tokenExp);
}

function getCustomerCacheExp() {
  const exp = localStorage.getItem('customer-exp-ch');

  if (exp) {
    return new Date(exp * 1000);
  }

  return new Date(0);
}

function removeCustomerCacheExp() {
  localStorage.removeItem('customer-exp-ch');
}

function removeWizardProgress() {
  localStorage.removeItem('wizard-current-step-tc');
  localStorage.removeItem('wizard-completed-steps-tc');
}

/* Destino guardado quando o guard manda uma rota protegida para o login.
   sessionStorage de proposito: vale so para esta aba e morre com ela. */
function saveReturnPath(path) {
  sessionStorage.setItem('return-path-tc', path);
}

function consumeReturnPath() {
  const path = sessionStorage.getItem('return-path-tc');

  sessionStorage.removeItem('return-path-tc');

  return path || undefined;
}

/* Logout explicito: um destino guardado antes nao pode sequestrar o proximo
   login desta aba. Fora de removeAuth de proposito — quem derruba a sessao
   (guard/401) chama removeAuth e em seguida salva o destino. */
function clearReturnPath() {
  sessionStorage.removeItem('return-path-tc');
}

/* Guarda a URL atual como destino pos-login (usado pelo interceptor de 401).
   Nunca guarda o proprio /login, que viraria um laco. */
function saveCurrentLocationAsReturnPath() {
  const { pathname, search } = window.location;

  if (pathname.startsWith('/login')) return;

  saveReturnPath(`${pathname}${search || ''}`);
}

export default {
  getUserOnStorage,
  saveUserOnStorage,
  saveTokenOnStorage,
  getTokenOnStorage,
  setThemeSettings,
  getThemeSettings,
  removeAuth,
  saveCustomerOnStorage,
  getCustomerOnStorage,
  removeCustomer,
  saveCustomerCacheExpOnStorage,
  getCustomerCacheExp,
  removeCustomerCacheExp,
  removeWizardProgress,
  saveReturnPath,
  consumeReturnPath,
  clearReturnPath,
  saveCurrentLocationAsReturnPath
};
